<template>
  <div>
    <div class="text-center mt-3">
      <b-img src="@/assets/logo@2x.png" width="214px" height="51px" alt="Hovland Conservatory"></b-img>
    </div>
    <br>
    <banner v-if="isShowingScheduleStep" text="Schedule" text-color="#ffffff" background-color="#595959"></banner>
    <banner v-if="isShowingReviewStep" text="Review" text-color="#ffffff" background-color="#595959"></banner>
    <banner v-if="isShowingFinishStep" text="Confirmed" text-color="#ffffff" background-color="#595959"></banner>
    <br>
    <b-container>
        <b-row>
          <b-col lg="6" offset-lg="3">

            <div v-if="isShowingScheduleStep">
              <p>Pick your location and then choose your start date and time. Available lesson times are displayed for the upcoming three weeks. New times are added frequently.
                <a href="https://www.hovlandconservatory.org/#CONTACT" target="_blank">Contact us</a> or check back often if you cannot find a time that works for your family.
              </p>

              <section>

                <div v-if="loadingInitialData">Loading...</div>

                <div v-if="!loadingInitialData && linkError === null">
                  <h3>Pick Location</h3>
                  <b-form-select :options="locationOptions" v-model="selectedLocation">
                    <template #first>
                      <b-form-select-option value="" disabled>-- Select Studio Location --</b-form-select-option>
                    </template>
                  </b-form-select>
                </div>

                <h5 class="text-danger" v-if="linkError !== null" v-html="linkError"></h5>

                <div v-if=" selectedLocation !== null">
                  <h3>Choose Start Date and Time</h3>
                  <calendar-day-select
                      :studio-id="selectedLocation"
                      :selected-day="selectedDay"
                      @update:selected-day="selectedDay = $event"
                      :selected-times="selectedTimes"
                      :time-slots="openings"
                      class="mb-2"
                  ></calendar-day-select>

                  <div v-for="student in students" :key="student.id">

                    <h3 class="studentName" @click="selectStudent(student)">
                        {{ student.firstName }} {{ student.lastName }} <small class="student-time-small">{{student.instrument}}</small>
                        <small class="student-time-small"><b>{{ formatStudentWeeklyTime(student) }}</b></small>

                    </h3>
                    <transition name="student-schedule">
                      <div v-show="selectedStudent !== null && selectedDay !== null && student.id === selectedStudent.id" class="student-schedule">
                        <slot-select
                            :studio-id="selectedLocation"
                            :time-slots="openings"
                            :student="student"
                            :selected-times="selectedTimes"
                            @student-selected-time="handleStudentSelectedTime"
                            @student-unselected-time="handleStudentUnselectedTime"
                            :selected-day="selectedDay"
                        ></slot-select>

                        <b-row>
                          <b-col class="buttons" >
                            <b-button class="prev-btn" variant="outline-secondary"
                                  v-if="canGoBack" @click="goBack">Back</b-button>
                          </b-col>
                          <b-col class="buttons" >

                            <b-button type="button" class="next-btn"  :variant="nextButtonVariant"
                                      v-if="shouldShowNext" @click="goToNextStudent">Next Student</b-button>
                            <b-button type="button" class="next-btn"  :variant="nextButtonVariant"
                                      v-if="shouldShowFinish" @click="goToFinishStep">Review</b-button>

                          </b-col>
                        </b-row>
                      </div>
                    </transition>

                  </div>
                  <br><br><br><br>
                </div>

            </section>
            </div>
            <div v-if="isShowingReviewStep">

              <h3>SELECTED</h3>
              <review-student-times :student-times="studentsWithFormattedTimes" :should-show-change="true"
                                    @change-clicked="selectStudent">

              </review-student-times>
              <br>
              <h3>Payment</h3>
              <h5>GRADES K-2</h5>
              <p style="margin-top: 0">Students in grades K-2 receive two free lessons under the Budding Musician Scholarship.
                <b>There are absolutely no charges during this scholarship period.</b>
                Following the scholarship, monthly tuition is $145 with a $30 annual membership fee and $20 for the first set of books.
                To discontinue lessons and never see a charge, notify us no more than two days following your second scholarship lesson.
              </p>

              <h5>GRADES 3-UP</h5>
              <p style="margin: 0">
              Students in grades 3-up receive our Love it Guarantee and can request a full refund through the first two lessons.
                Monthly tuition is $145 with a $30 annual membership fee and $20 for the first set of books.
              </p>
              <p>Confirm your lesson time by setting up a payment account below.</p>
<!--              <p>Confirm your lesson time by setting up a payment account and clicking submit.-->

<!--              </p>-->
<!--              <p>-->
<!--                Monthly Tuition is $145 and charged on the 1st of each month. The flat monthly rate is calculated by dividing the 45-week school year into 12 equal monthly payments.-->
<!--              </p>-->
<!--              <p>-->
<!--                Initial per student payment includes the prorated monthly tuition, $30 yearly membership, and $20 for the first set of books.-->
<!--              </p>-->
<!--              <p>-->
<!--                If after two lessons you decide not to continue, you can request a full refund of this initial payment.-->
<!--              </p>-->


              <br>
              <div>
                <h3>Confirm</h3>
                <b-form id="submitForm" @submit.prevent="handleFormSubmitted">
              <b-form-row>
                <b-col>
                  <b-form-input v-model="billingData.parentName" name="ccname" autocomplete="cc-name" placeholder="Parent Name" required></b-form-input>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-input v-model="billingData.streetAddress" name="address" autocomplete="street-address" placeholder="Billing Street Address" required></b-form-input>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col>
                  <b-form-input v-model="billingData.city"  name="billingCity" placeholder="City" required></b-form-input>
                </b-col>
                <b-col cols="2">

                  <b-form-input v-model="billingData.state"  name="billingState" placeholder="State" required></b-form-input>
                </b-col>
                <b-col>
                  <b-form-input v-model="billingData.zip"  name="billingZip" placeholder="Zip" required></b-form-input>
                </b-col>
              </b-form-row>

              <b-form-row>
                <b-col class="text-center">
                  <b-img src="@/assets/cc-images@2x.png" height="22" width="141" style="margin-top: 10px" ></b-img>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col>
                  <b-form-input v-model="billingData.cardNumber"  name="cardnumber" autocomplete="cc-number" placeholder="Card number" required></b-form-input>
                </b-col>
              </b-form-row>
              <b-form-row>
                <b-col cols="4">
                  <b-form-input v-model="billingData.cardExp"  name="exp-date" autocomplete="cc-exp" placeholder="MM/YYYY" required></b-form-input>
                </b-col>
                <b-col cols="4">
                  <b-form-input v-model="billingData.cardCode"  name="cvc" autocomplete="cc-csc" placeholder="Card Code" required></b-form-input>
                </b-col>
                <b-col cols="4">
                  <b-button type="submit" :disabled="isSubmitting" form="submitForm" class="next-btn"  variant="primary"
                            v-if="shouldShowSubmit" >Submit</b-button>

                </b-col>
              </b-form-row>
                  <b-form-row>
                    <b-col>
                      <div v-if="isSubmitting" class="text-center mb-3 d-flex align-items-center">
                       <b-spinner font-scale="4"></b-spinner>
                     </div>
                    </b-col>
                  </b-form-row>

              <div v-if="errorMsg !== null" class="text-danger error-message">{{ errorMsg }}</div>

              </b-form>

              </div>



            </div>
            <div v-if="isShowingFinishStep">
              <p>We can't wait to meet you and your family. Watch your email for more information on your upcoming lessons. </p>
              <h3>SELECTED</h3>
              <review-student-times :student-times="studentsWithFormattedTimes" :should-show-change="false">
              </review-student-times>
            </div>

          </b-col>
        </b-row>
    </b-container>

  </div>
</template>

<script>

import {computed, onMounted, reactive, readonly, ref} from "@vue/composition-api";

import Banner from '@/components/Banner'
import SlotSelect from "@/components/scheduling/SlotSelect";

import getScheduleAPI, {formatLocalTime} from "@/model/scheduleAPI";
import {DateTime} from "luxon";
import ReviewStudentTimes from "@/components/scheduling/ReviewStudentTimes";
import CalendarDaySelect from "@/components/scheduling/CalendarDaySelect";


export default {
  name: 'Schedule',

  components: {
    SlotSelect,
    Banner,
    ReviewStudentTimes,
    CalendarDaySelect,
  },
  setup(props, {root}) {
    const api = getScheduleAPI();
    let locations = ref([]);
    let students = ref([]);
    let familyInfo = ref(null);

    let openings = ref([]);

    const selectedLocation = ref(null);
    const selectedStudent = ref(null);
    const selectedDay = ref(null);

    const selectedTimes = ref([]);

    const isShowingReviewStep = ref(false);
    const isShowingFinishStep = ref(false);

    const billingData = reactive({
      parentName: null,
      streetAddress: null,
      city: null,
      state: null,
      zip: null,
      cardNumber: null,
      cardExp: null,
      cardCode: null,
    });

    const linkError = ref(null)
    const linkErrorText = "Something went wrong: Please double-check the link. Contact <a href=\"mailto:support@hovlandconservatory.org\">support@hovlandconservatory.org</a> if you are still having an issue."
    const loadingInitialData = ref(true)

    onMounted(async () => {
      const token = root.$route.query.t;
      loadingInitialData.value = true;
      try {
        familyInfo.value = await api.fetchLinkData(token);
      } catch(e) {
        linkError.value = linkErrorText;
        loadingInitialData.value = false;
      }
      if (familyInfo.value.parentFirst === undefined) {
        linkError.value = linkErrorText
        loadingInitialData.value = false;
        return;
      }

      // Fill out the billing info that we know about
      billingData.parentName =  `${familyInfo.value.parentFirst} ${familyInfo.value.parentLast}`;

      // Fetch additional data (simultaneously).
      const locationsPromise = api.fetchStudios(familyInfo.value.regionID)
      const openingsPromise = api.fetchScheduleOpenings()
      locations.value = await locationsPromise;
      openings.value = await openingsPromise;

      students.value = familyInfo.value.students;

      loadingInitialData.value = false;

      // Select first student
      if (students.value.length > 0) {
        selectedStudent.value = students.value[0];
      }
    });


    function handleStudentSelectedTime({student, slot}) {

      const existingStudentTimeIndex = selectedTimes.value.findIndex((time) => time.student.id === student.id);
      if (existingStudentTimeIndex >= 0) {
        // remove existing student time
        selectedTimes.value.splice(existingStudentTimeIndex, 1);
      }

      selectedTimes.value.push({student, slot});
    }
    function handleStudentUnselectedTime({student}) {
      // remove existing student time
      const existingStudentTimeIndex = selectedTimes.value.findIndex((time) => time.student.id === student.id);
      selectedTimes.value.splice(existingStudentTimeIndex, 1);
    }

    function getSelectedStudentTime(student) {
      return selectedTimes.value.find((s) => s.student.id+"" === student.id+"");
    }

    const hasAtLeastOneStudentSelectedTime = computed(() => {
      return selectedTimes.value.length > 0;
    });

    const shouldShowNext = computed(() => {
      const currentStudentIndex = students.value.indexOf(selectedStudent.value);
      return currentStudentIndex < (students.value.length - 1)  && !isShowingReviewStep.value;
    })

    function goToNextStudent() {
      const currentStudentIndex = students.value.indexOf(selectedStudent.value);
      selectedStudent.value = students.value[currentStudentIndex + 1];
    }
    function goBack() {
      if (isShowingReviewStep.value) {
        isShowingReviewStep.value = false;
        return;
      }
      const currentStudentIndex = students.value.indexOf(selectedStudent.value);
      selectedStudent.value = students.value[currentStudentIndex - 1];
    }


    const canGoBack = computed(() => {
      const currentStudentIndex = students.value.indexOf(selectedStudent.value);
      return currentStudentIndex > 0 && isShowingFinishStep.value === false;
    });

    const shouldShowReview = computed(() => {
      const currentStudentIndex = students.value.indexOf(selectedStudent.value);
      return currentStudentIndex >= (students.value.length - 1) && !isShowingReviewStep.value && !isShowingFinishStep.value;
    });

    function selectStudent(student) {
      isShowingReviewStep.value = false;
      selectedStudent.value = student;
      // Re-select student's studio and time, if selected, so we show that DOW.
      const studentTime = getSelectedStudentTime(student);
      if (studentTime) {
        selectedDay.value = DateTime.fromISO(studentTime.slot.date);
      }

    }

    function goToFinishStep() {
      // This timeout prevents the form from submitting early - kind of hacky but this works reliably.
      window.setTimeout( () => {
        isShowingReviewStep.value = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 0);
    }

    function formatStudentTime(student) {
      const selectedTimeSlot = getSelectedStudentTime(student);
      if (selectedTimeSlot === undefined) {
        return "No Time Selected";
      } else {
        const dt = DateTime.fromISO(selectedTimeSlot.slot.date);
        const weeklyTime = `${dt.toLocaleString({weekday: 'short'})} ${formatLocalTime(dt.toISOTime({includeOffset: false}))}`
        const startingDate = dt.toLocaleString({month: 'short', day: '2-digit'});
        const studio = locations.value.find((studio) => studio.id+"" === selectedTimeSlot.slot.studioID+"")
        return `${weeklyTime} starting ${startingDate} in ${studio.name}`;
      }
    }
    function formatStudentWeeklyTime(student) {

      // Show new selected time if applicable
      const selectedTimeSlot = getSelectedStudentTime(student);
      if (selectedTimeSlot !== undefined) {
        const dt = DateTime.fromISO(selectedTimeSlot.slot.date);
        return `${dt.toLocaleString({weekday: 'short'})} ${formatLocalTime(dt.toISOTime({includeOffset: false}))}`

      } else if (student.lessonTime) {
        // Show the student's current lesson time, if any.
        const dt = DateTime.fromISO(student.lessonTime.date);
        return `${dt.toLocaleString({weekday: 'short'})} ${formatLocalTime(dt.toISOTime({includeOffset: false}))}`
      } else {
        return "";
      }
    }

    const shouldShowSubmit = computed(() => {
      return isShowingReviewStep.value === true && isShowingFinishStep.value === false;
    })

    const errorMsg = ref(null);
    const isSubmitting = ref(false);

    async function handleFormSubmitted() {
      const submission = {
        chosenTimes: selectedTimes.value.map((chosenTime) => {
          return {
            studentID: chosenTime.student.id,
            startDate: chosenTime.slot.date,
            openingID: chosenTime.slot.id,
          }
        }),
        billingInfo: {
          cardName: billingData.parentName,
          cardBillingAddress: billingData.streetAddress,
          cardBillingCity: billingData.city,
          cardBillingState: billingData.state,
          cardBillingZip: billingData.zip,
          cardNumber: billingData.cardNumber,
          cardExp: billingData.cardExp,
          cardCode: billingData.cardCode,
        }
      }

      isSubmitting.value = true;
      const result = await api.reserveScheduleTimes(submission, root.$route.query.t);
      isSubmitting.value = false;

      if (result.errors && result.errors.length > 0) {
        errorMsg.value = result.errors[0];
        return;
      }
      isShowingReviewStep.value = false;
      isShowingFinishStep.value = true;
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const isShowingScheduleStep = computed(() => {
      return (!isShowingReviewStep.value && !isShowingFinishStep.value);
    })

    const studentsWithFormattedTimes = computed(() => {
      return students.value.map((s) => {
        return {student: s, time: formatStudentTime(s)};
      });
    })

    const nextButtonVariant = computed(() => {
      if (getSelectedStudentTime(selectedStudent.value) !== undefined) {
        return 'primary'
      }
      return 'outline-secondary'
    })

    return {
      locations,
      locationOptions: computed(() => {
        return locations.value.map(l => {
          return {text: l.name, value: l.id};
      })}),
      selectedLocation,
      selectedDay,
      students,
      selectedStudent,
      selectedTimes: readonly(selectedTimes),
      openings,
      handleStudentSelectedTime,
      handleStudentUnselectedTime,
      formatStudentTime,
      formatStudentWeeklyTime,
      studentsWithFormattedTimes,
      hasAtLeastOneStudentSelectedTime,
      shouldShowNext,
      nextButtonVariant,
      goToNextStudent,
      goBack,
      canGoBack,
      shouldShowFinish: shouldShowReview,
      goToFinishStep,
      isShowingScheduleStep,
      isShowingReviewStep,
      isShowingFinishStep,
      selectStudent,

      shouldShowSubmit,
      isSubmitting,
      billingData,
      handleFormSubmitted,
      errorMsg,
      linkError,
      loadingInitialData,
    }
  }
}
</script>

<style>
h3 {
  background-color: #505050;
  color: white;
  text-align: center;
  text-transform: uppercase;
  font-family: 'Lato', sans-serif;
  font-weight: 600;
  padding: .5rem 0;
  font-size: 16pt;
  margin-top: .5rem;
}

h5 {
  margin-top: 1.5rem;
  margin-bottom: 0;
}

</style>

<style scoped>

p {
  color: #595959;
  margin: .5rem auto;
  font-size: 1rem;
}

select {
  color: #595959;
  border-color: #595959;
}

.student-select {
  height: 2rem;
  padding: 3px;
  border-radius: 10px;
  border: 1px solid #595959;
  color: #595959;
}
.student-select.selected {
  border-color: red;
  color: red;
}

.student-select.chosen {

}


.studentName {
  margin-top: .5rem;
  margin-bottom: 0;
  cursor: pointer;
}

.student-time-small {
  font-size: .8rem;
  margin: 0 1rem;
  vertical-align: middle;
}
.buttons {
  display: flex;
  justify-content: space-between;
}
.next-btn, .prev-btn {
  flex: 1 0 auto;

  border-radius: 20px;
  text-transform: uppercase;
  /* match form input sizing */
  margin: .5rem 0;
  height: calc(1.5em + 0.75rem + 2px);
  width: 100%;
}

.form-row input {
  border: 1px solid #505050;
  border-radius: 0;
  margin-top: .5rem;
}

.error-message {
  font-size: 1.1rem;
  margin: 1rem;
}

.student-schedule {
  transition: max-height .33s ease-in-out;
  overflow: hidden;
}
.student-schedule-enter {
  max-height: 0;
}
.student-schedule-enter-to {

  max-height: 550px;
}
.student-schedule-leave {

  max-height: 550px;
}
.student-schedule-leave-to {
  max-height: 0;
}


</style>